import React, { useEffect } from "react";
import { Outlet } from "react-router-dom";
import { ToastContainer } from "react-toastify";

import { useAppContext } from "providers/AppProvider";

import { CloseButton } from "components/common/Toast";
import { useGetUiMessagesQuery } from "components/services/messages/messagesService";
import "react-datepicker/dist/react-datepicker.css";
import "react-toastify/dist/ReactToastify.css";

const App = () => {
  const HTMLClassList = document.getElementsByTagName("html")[0].classList;
  const {
    config: { navbarPosition },
  } = useAppContext();
  // Populate the UI-messages cache on app load. The `notify` utility reads
  // from this cache; without it, toasts would fall back to displaying raw keys.
  useGetUiMessagesQuery();

  useEffect(() => {
    const ua = navigator.userAgent;
    if (/Windows/.test(ua)) {
      HTMLClassList.add("windows");
    }
    // Chrome detection must exclude Edge ("Edg") and Opera ("OPR"), which
    // include "Chrome" in their UA string.
    if (/Chrome/.test(ua) && !/Edg|OPR/.test(ua)) {
      HTMLClassList.add("chrome");
    }
    if (/Firefox/.test(ua)) {
      HTMLClassList.add("firefox");
    }
    // Safari includes "Safari" but Chrome's UA does too — require Safari and
    // exclude Chrome/Android tokens to avoid false positives.
    if (/^((?!Chrome|Android).)*Safari/.test(ua)) {
      HTMLClassList.add("safari");
    }
  }, [HTMLClassList]);

  useEffect(() => {
    if (navbarPosition === "double-top") {
      HTMLClassList.add("double-top-nav-layout");
    }
    return () => HTMLClassList.remove("double-top-nav-layout");
  }, [navbarPosition]);

  return (
    <>
      <Outlet />

      <ToastContainer
        closeButton={CloseButton}
        icon={false}
        position="bottom-left"
      />
    </>
  );
};

export default App;
